import React from 'react';
import { MenuIcon } from 'lucide-react';
export const Header = () => {
  return <header className="fixed w-full py-4 px-6 md:px-12 flex justify-between items-center z-10" data-id="element-133">
      <div className="text-white font-bold text-xl md:text-2xl" data-id="element-134">
        Maila Akbar
      </div>
      <div className="hidden md:flex space-x-8" data-id="element-135">
        <a href="#home" className="text-white hover:text-purple-300 transition-colors" data-id="element-136">
          Home
        </a>
        <a href="#about" className="text-white hover:text-purple-300 transition-colors" data-id="element-137">
          About
        </a>
        <a href="#projects" className="text-white hover:text-purple-300 transition-colors" data-id="element-138">
          Projects
        </a>
        <a href="#cv" className="text-white hover:text-purple-300 transition-colors" data-id="element-139">
          CV
        </a>
        <a href="#contact" className="text-white hover:text-purple-300 transition-colors" data-id="element-140">
          Contact
        </a>
      </div>
      <button className="md:hidden text-white" data-id="element-141">
        <MenuIcon size={24} data-id="element-142" />
      </button>
    </header>;
};